const Data = [
  {
    id: 1,
    category: "education",
    icon: "icon-graduation",
    year: "2023 - Present",
    title: "Applied Bachelor's Degree",
    desc: "Pursuing a D4 degree in Informatics and Computer Engineering at Politeknik Negeri Ujung Pandang.",
  },
  {
    id: 2,
    category: "education",
    icon: "icon-graduation",
    year: "2020 - 2023",
    title: "High School Diploma",
    desc: "Completed 5 semesters at MAN Insan Cendekia Gowa, the #1 School in South Sulawesi Province. Graduated from SMAN 10 Makassar in 2023.",
  },
  {
    id: 3,
    category: "experience",
    icon: "icon-briefcase",
    year: "2024 - Present",
    title: "Back-End Developer",
    desc: "Focused on building robust server-side applications and optimizing database management for seamless user experiences.",
  },
  {
    id: 4,
    category: "experience",
    icon: "icon-briefcase",
    year: "2022 - 2024",
    title: "Front-End & UI/UX Designer",
    desc: "Contributed to innovative web designs and user-centric interfaces at Makassar Robotics, enhancing user experiences.",
  },
];

export default Data;
